class UsersUtil {
  hasRole(user, roleName) {
    console.log(user)
    return user.roles.filter((role) => role.name === roleName).length > 0;
  }

  hasType(user, typeName) {
    return user.accountable_type === typeName;
  }

  isAdmin(user) {
    return (
      this.hasRole(user, ROLES.SPACKLE_ADMIN) ||
      this.hasRole(user, ROLES.BUSINESS_DEVELOPMENT) ||
      this.hasRole(user, ROLES.FIELD)
    );
  }

  isSpackleAdmin(user) {
    return this.hasRole(user, ROLES.SPACKLE_ADMIN);
  }
}

export const ROLES = {
  OWNER: 'owner',
  SPACKLE_ADMIN: 'spackle_admin',
  BUSINESS_DEVELOPMENT: 'business_development',
  FIELD: 'field',
  CLIENT_BUILDING_MANAGER: 'building_manager',
  CLIENT_WO_CREATOR: 'wo_creator',
  CLIENT_WO_APPROVER: 'wo_approver',
  CLIENT_WO_COMPLETION_APPROVER: 'wo_completion_approver',
  CONTRACTOR_PROJECT_MANAGER: 'project_manager',
  CONTRACTOR_SENIOR_ACCOUNTANT: 'senior_accountant',
  CONTRACTOR_FIELD_PERSONNEL: 'field_personnel',
  CONTRACTOR_TEAM_COORDINATOR: 'team_coordinator',

  CONTRACTOR_FOREMAN: 'foreman',
  GENERAL_CONTRACTOR_CO_FOUNDER: 'co_founder',
  GENERAL_CONTRACTOR_PROJECT_ENGINEER: 'project_engineer',
  GENERAL_CONTRACTOR_PROJECT_MANAGER: 'project_manager',
  GENERAL_CONTRACTOR_SENIOR_PROJECT_MANAGER: 'senior_project_manager',
  GENERAL_CONTRACTOR_SENIOR_PROJECT_ADMIN: 'senior_project_administrator',
  GENERAL_CONTRACTOR_SENIOR_PROJECT_EXECUTIVE: 'project_executive',
  GENERAL_CONTRACTOR_SENIOR_BUSINESS_MANAGER: 'business_manager',
  GENERAL_CONTRACTOR_SUPERINTENDENT: 'superintendent',
  GENERAL_CONTRACTOR_ASSISTANT_SUPERINTENDENT: 'assistant_superintendent',
  GENERAL_CONTRACTOR_SENIOR_SUPERINTENDENT: 'senior_superintendent',
  GENERAL_CONTRACTOR_ASSISTANT_FIELD_OPS_MANAGER: 'field_ops_manager',
  GENERAL_CONTRACTOR_SENIOR_ACCOUNTANT: 'senior_accountant',
  GENERAL_CONTRACTOR_TEAM_COORDINATOR: 'team_coordinator',
};

export const TYPES = {
  // resource_types
  CLIENT: 'Client',
  CONTRACTOR: 'Contractor',
  GENERAL_CONTRACTOR: 'GeneralContractor',
  ARCHITECT: 'Architect',
  LANDLORD: 'Landlord',
};

export const CLIENT_ROLES = {
  owner: 'Administrator',
  [ROLES.CLIENT_BUILDING_MANAGER]: 'Building Manager',
  wo_approver: 'May Approve Work Orders',
  wo_completion_approver: 'May Approve Completion of Work',
};

export const CONTRACTOR_ROLES = {
  owner: 'Administrator',
  project_manager: 'Project Manager',
  field_personnel: 'Field Personnel',
  senior_accountant: 'Senior Accountant',
  team_coordinator: 'Team Coordinator',
  foreman: 'Foreman',
};

export const GENERAL_CONTRACTOR_ROLES = {
  co_founder: 'Co-Founder',
  project_engineer: 'Project Engineer',
  project_manager: 'Project Manager',
  senior_project_manager: 'Senior Project Manager',
  senior_project_administrator: 'Senior Project Administrator',
  project_executive: 'Project Executive',
  business_manager: 'Business Manager',
  superintendent: 'Superintendent',
  assistant_superintendent: 'Assistant Superintendent',
  senior_superintendent: 'Senior Superintendent',
  field_ops_manager: 'Field Operations Manager',
  senior_accountant: 'Senior Accountant',
  team_coordinator: 'Team Coordinator',
  owner: 'Administrator',
  laborer: 'Laborer',
};

export const ADMIN_ROLES = {
  spackle_admin: 'Spackle Admin',
  [ROLES.BUSINESS_DEVELOPMENT]: 'Business Development',
  [ROLES.FIELD]: 'Field',
};

export const usersUtil = new UsersUtil();
export default new UsersUtil();



// WEBPACK FOOTER //
// ./src/services/utils/users-util.js